import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Element #root nije pronađen.');
}
normalizeDirectRoute();
disableBrowserTranslation(rootElement);
const root = createRoot(rootElement);
root.render(<LoadingApp data-id="element-178" data-mp="269tw9c9dywbf" />);
void import('./App').then(({
  App
}) => root.render(<App data-id="element-179" data-mp="266xxxmtmm5mg" />)).catch((error: unknown) => root.render(<StartupError error={error} data-id="element-180" data-mp="2a9ug5cf97zpv" />));
function LoadingApp() {
  return <main className="flex min-h-screen items-center justify-center bg-background p-6 text-center text-gray-600" data-id="element-181" data-mp="2f9gvpsik1s1u">
      Učitavamo JumpLand…
    </main>;
}
function StartupError({
  error
}: {
  error: unknown;
}) {
  const message = error instanceof Error ? error.message : 'Nepoznata greška.';
  return <main className="flex min-h-screen items-center justify-center bg-background p-6" data-id="element-182" data-mp="2tzepcnz979yf">
      <section className="w-full max-w-xl rounded-3xl border border-red-200 bg-white p-8 text-center shadow-sm" data-id="element-183" data-mp="2y06yzic1fgv8">
        <h1 className="text-2xl font-black text-gray-900" data-id="element-184" data-mp="1amrkijv9so8y">
          Aplikacija se ne može učitati
        </h1>
        <p className="mt-3 text-gray-600" data-id="element-185" data-mp="15m3thy71k7eq">
          Prikazana je stvarna greška kako preview ne bi ostao prazan.
        </p>
        <pre className="mt-6 overflow-x-auto rounded-2xl bg-red-50 p-4 text-left text-sm text-red-900" data-id="element-186" data-mp="10okdotup3mko">
          {message}
        </pre>
      </section>
    </main>;
}
// Chrome prijevod mijenja tekst u stranici i ruši React prikaz (removeChild greška).
// Stranica je već na hrvatskom, pa prijevod isključujemo za cijelu aplikaciju.
function disableBrowserTranslation(element: HTMLElement) {
  const html = document.documentElement;
  html.setAttribute('lang', 'hr');
  html.setAttribute('translate', 'no');
  html.classList.add('notranslate');
  element.setAttribute('translate', 'no');
  element.classList.add('notranslate');
  if (!document.querySelector('meta[name="google"]')) {
    const meta = document.createElement('meta');
    meta.name = 'google';
    meta.content = 'notranslate';
    document.head.appendChild(meta);
  }
}
function normalizeDirectRoute() {
  if (window.location.hash || window.location.pathname === '/') return;
  window.history.replaceState(null, '', `/#${window.location.pathname}${window.location.search}`);
}